import {Flex, Heading, useColorModeValue} from "@chakra-ui/react";
import PropTypes from "prop-types";

function CategoryHeader(props) {
    const { categoryName } = props
    const HeaderBG = useColorModeValue('#E8ECED', '#2F2F2F')
    const TextColor = useColorModeValue('black', 'white')
    return(
        <Flex p={4} bg={HeaderBG} borderTopLeftRadius='8px' borderTopRightRadius='8px'>
            <Heading
                size="md"
                fontFamily="heading"
                fontWeight="bold"
                color={TextColor}
                lineHeight="1.2"
            >
                {categoryName}
            </Heading>
        </Flex>
    )
}

CategoryHeader.propTypes = {
    categoryName: PropTypes.string.isRequired,
}

export default CategoryHeader